export enum AdjustmentType {
  PREPAYMENT = <any>'PREPAYMENT',
  REBATE = <any>'REBATE'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/adjustment-type.enum.ts